import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import { useTheme } from '../ThemeContext';
import LogoDark from '../assets/m3-logo-square.svg';
import LogoLight from '../assets/m3-logo-square-light.svg';

const handleContact = (event: React.MouseEvent<HTMLElement>) => {
  let core = 'frank';
  let adj = 'm3computing';
  event.preventDefault();
  window.location.href = 'mailto:' + core + '@' + adj + '.com';
};

export default function MainLayout() {
  const { theme, toggleTheme } = useTheme();
  const logo = theme === 'dark' ? LogoLight : LogoDark;

  return (
    <>
      <Navbar variant="dark" fixed="top" expand="lg" className="m3-navbar">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img
              src={logo}
              height="36"
              className="d-inline-block align-middle"
              alt="M3 Computing logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="site-navbar" />
          <Navbar.Collapse id="site-navbar">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/">Home</Nav.Link>
              <Nav.Link as={Link} to="/services">Services</Nav.Link>
            </Nav>
            <Nav className="align-items-center gap-2">
              <button
                className="m3-theme-toggle"
                onClick={toggleTheme}
                aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
              >
                {theme === 'dark' ? '☀' : '☾'}
              </button>
              <Button className="m3-contact-btn" onClick={handleContact}>
                Contact Us
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <main className="m3-main">
        <Container>
          <Outlet />
        </Container>
      </main>

      <footer className="m3-footer">
        <Container>
          <p className="mb-2">
            Ready to start a conversation?{' '}
            <Button size="sm" className="m3-contact-btn" onClick={handleContact}>
              Contact Us
            </Button>
          </p>
          <p className="mb-0 small">&copy; 2026 M3 Computing, LLC</p>
        </Container>
      </footer>
    </>
  );
}
